angular.module('picmonicng').directive('learnFact', [
  '$interval',
  '$modal',
  'FactEditModal',
  '$timeout',
  function ($interval, $modal, FactEditModal, $timeout) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/templates/directives/learn-fact.html',
      scope: {
        fact: '=',
        playerService: '=',
      },
      controller: [
        '$scope',
        'FactsResource',
        'UserService',
        'PermissionsService',
        function ($scope, FactsResource, UserService, PermissionsService) {
          $scope.UserService = UserService;
          $scope.PermissionsService = PermissionsService;

          $scope.edit = function () {
            if ($scope.fact.entity_type_id == 1) {
              FactEditModal.open(null, $scope.fact, function () {
                $scope.playerService.selectFact($scope.fact);
              });
            }
          };

          $scope.hideFactSummary = function (playerService) {
            switch (playerService.mode) {
              case 'player':
                return !$scope.fact.definition && $scope.fact.entity_type_id == 1;
              case 'review':
                return playerService.reviewStep == 1;
              case 'quiz':
                return playerService.quizStep == 1;
              case 'learn':
                return (
                  playerService.audioElement && !playerService.audioElement.paused && !UserService.user.learn_definition
                );
            }
          };

          $scope.delete = function () {
            if ($scope.fact.entity_type_id == 1) {
              function deleteFact() {
                $scope.fact.resource = 'facts';
                $scope.fact.resource_id = $scope.fact.fact_id;
                var promise = $scope.fact.$delete();
                promise.then(function () {
                  $scope.playerService.currentFacts = _.without($scope.playerService.currentFacts, $scope.fact);
                });
                return promise;
              }

              $modal.open({
                templateUrl: '/templates/modals/delete-confirm.html',
                windowClass: 'below-nav learn-master-complete',
                backdropClass: 'below-nav',
                size: 'sm',
                controller: [
                  '$scope',
                  '$modalInstance',
                  function ($scope, $modalInstance) {
                    $scope.confirmation_text = 'Are you sure you want to delete this fact?';

                    $scope.confirm = function () {
                      $scope.loading = true;

                      deleteFact().then(function () {
                        $scope.cancel();
                      });
                    };

                    $scope.cancel = function () {
                      $modalInstance.close();
                    };
                  },
                ],
              });
            }
          };

          $scope.downloadCharacter = function () {
            window.location = '/api/v2/facts/' + $scope.fact.fact_id + '/download_character';
          };

          $scope.outdent = function () {
            if ($scope.fact.indent > 0) {
              $scope.fact.indent--;
              $scope.playerService.addToHistory();
            }
          };

          $scope.indent = function () {
            if ($scope.fact.indent < 3) {
              $scope.fact.indent++;
              $scope.playerService.addToHistory();
            }
          };
        },
      ],
      link: function (scope, element, attrs) {
        scope.$watch(
          function () {
            return scope.fact.selected;
          },
          function (newVal, oldVal) {
            if (newVal && scope.playerService.mode != 'editor') {
              $timeout(function () {
                if (element.parents('.player-sidebar-wrapper').length) {
                  element.parents('.player-sidebar-wrapper').animate(
                    {
                      scrollTop: element[0].offsetTop,
                    },
                    300
                  );
                } else if (element.parents('.learn-info').length) {
                  element.parents('.learn-info').animate(
                    {
                      scrollTop: element[0].offsetTop,
                    },
                    500
                  );
                }
              }, 50);
            }
          }
        );

        element.bind('click', function (event) {
          scope.$apply(function () {
            if (scope.playerService.locked) return;

            if (
              !angular.element(event.target).hasClass('fact-classifier-clickable') &&
              (angular.element(event.target).hasClass('fact-header-wrapper') ||
                angular.element(event.target).parents('.fact-header-wrapper').length ||
                angular.element(event.target).hasClass('md-pencil'))
            ) {
              if (
                (scope.playerService.mode != 'editor' && !scope.fact.header) ||
                (scope.playerService.mode == 'editor' &&
                  scope.playerService.hasAccess('workflow', 'fact_edit', scope.fact))
              ) {
                if (!scope.fact.selected) {
                  scope.playerService.selectFact(scope.fact);
                } else if (scope.playerService.mode == 'quiz' && scope.playerService.quiz_mode) {
                  return;
                } else {
                  if (scope.playerService.mode != 'learn' && window.innerWidth <= 768) {
                    scope.playerService.nextFactStep();
                  } else {
                    scope.playerService.clearSelectedFact();
                  }
                }

                if (scope.playerService.audioElement) {
                  if (scope.fact.audio[scope.playerService.audioMode]) {
                    scope.playerService.seek(scope.fact.audio[scope.playerService.audioMode].start);
                  } else {
                    scope.playerService.audioElement.pause();
                  }
                }
              }
            }
          });
        });

        scope.playFactAudio = function () {
          scope.playerService.playFactAudio(scope.fact);
        };

        var interval;

        scope.selectQuizAnswer = function (answer) {
          answer.selected = true;
          scope.playerService.quizStep = 2;
          if (answer.name == scope.fact.name) {
            scope.playerService.quizAnswer('y');

            scope.time_remaining = 3;

            interval = $interval(function () {
              scope.time_remaining -= 1;

              if (scope.time_remaining == 0) {
                scope.nextFact();
              }
            }, 1000);
          } else {
            scope.playerService.quizAnswer('n');
          }
        };

        scope.nextFact = function () {
          if (interval) {
            $interval.cancel(interval);
            scope.time_remaining = null;
          }
          scope.playerService.nextFact();
        };
      },
    };
  },
]);
